import { PartyContactMechanisms } from '../../../model/school.model';
import { User } from './../../auth/model/user.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class UserProfileService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getMyProfile(): Observable<any> {
        return this.get<any>(EndPoints.userProfile_getMyProfile, '', '');
    }

    getPartyRoles(partyId: number): Observable<any> {
        return this.get<any>(EndPoints.userProfile_getPartyRoles, '', partyId);
    }

    getRegionsByPartyId(partyId: number): Observable<any> {
        return this.get<any>(EndPoints.userProfile_getRegionsByPartyId, '', partyId);
    }

    checkUserId(userId: string, loginDetailsId: number, accountRequestId?: number) {
        accountRequestId = accountRequestId ? accountRequestId : 0;

        return this.post<any>(EndPoints.userProfile_checkUserId, false, null, {
            userId: userId,
            loginDetailsId: loginDetailsId,
            accountRequestId: accountRequestId
        });
    }

    changePassword(oldPassword: string, newPassword: string): Observable<any> {
        return this.post<any>(EndPoints.userProfile_changePassword, false, null, { oldPassword: oldPassword, newPassword: newPassword });
    }

    updateMyContactInfo(
        editUser: User,
        partyContactMechanisms: PartyContactMechanisms[],
        deletePartyContactMechanisms: PartyContactMechanisms[]
    ): Observable<any> {
        return this.post<any>(EndPoints.userProfile_updateMyContactInfo, false, null, {
            editUser: editUser,
            partyContactMechanisms: partyContactMechanisms,
            deletePartyContactMechanisms: deletePartyContactMechanisms
        });
    }
}
